var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoBuildingsRenoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 580,
    height: 620,
    viewBox: "0 0 580 620",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_964_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.249 427.768H142.786M378.357 280.536H201.678",
    stroke: "white",
    strokeWidth: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 575H555.035M80.0647 575L262.338 64.4C264.401 58.7154 268.164 53.8038 273.117 50.3329C278.069 46.862 283.97 45 290.017 45C296.065 45 301.966 46.862 306.918 50.3329C311.87 53.8038 315.634 58.7154 317.697 64.4L499.97 575H80.0647Z",
    stroke: "white",
    strokeWidth: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_964_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 580,
    height: 620,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBuildingsRenoWhite);
export default __webpack_public_path__ + "static/media/ico_buildings_reno_white.5176fe72780840c73e41200004fde04f.svg";
export { ForwardRef as ReactComponent };